import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.afterpay = {
      variant: 'flex.row.start.center',

      text: {
        color: 'mediumDarkGray',
        fontSize: [3, 4],
        mb: 0,
      },

      link: {
        ml: 2,
      },

      pill: {
        width: ['56px', '94px'],
        height: ['12px', '20px'],
        borderRadius: '10px',
        bg: '#B2FCE4',
        position: 'relative',
        overflow: 'hidden',
      },

      logo: {
        width: ['50px', '82px'],
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      },
    };
  })()
);
